/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddReservation200,
    AddReservationBody,
    GetOrdersByReservationId200,
    GetOrdersByReservationIdParams,
    GetReservation200,
    GetReservationParams,
    PayReservationBody,
    PayReservationParams,
    RequestStatusResponseResponse,
    VerifyReservation200,
    VerifyReservationBody,
    WaitlistSubscriptionCreateBodyBody,
    WaitlistSubscriptionCreateSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Create a new reservation
 */
export const addReservation = (addReservationBody: AddReservationBody, signal?: AbortSignal) => {
    return customInstance<AddReservation200>({
        url: `/reservation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addReservationBody,
        signal,
    });
};

export const getAddReservationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addReservation>>,
        TError,
        { data: AddReservationBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addReservation>>,
    TError,
    { data: AddReservationBody },
    TContext
> => {
    const mutationKey = ['addReservation'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addReservation>>,
        { data: AddReservationBody }
    > = (props) => {
        const { data } = props ?? {};

        return addReservation(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddReservationMutationResult = NonNullable<Awaited<ReturnType<typeof addReservation>>>;
export type AddReservationMutationBody = AddReservationBody;
export type AddReservationMutationError = APIErrorResponseResponse;

/**
 * @summary Create a new reservation
 */
export const useAddReservation = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addReservation>>,
        TError,
        { data: AddReservationBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addReservation>>,
    TError,
    { data: AddReservationBody },
    TContext
> => {
    const mutationOptions = getAddReservationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Runs the show's `verificationScript` (if any) against the same denormalized
cart payload that addReservation sees, without persisting anything. Used
by the widget on cart change so the booking summary can display the
adjusted total or a localized error before the user pays. Always re-run
server-side at addReservation; the client-facing result is advisory.

 * @summary Preflight a reservation through the show's verification script
 */
export const verifyReservation = (
    verifyReservationBody: VerifyReservationBody,
    signal?: AbortSignal,
) => {
    return customInstance<VerifyReservation200>({
        url: `/reservation/verify`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: verifyReservationBody,
        signal,
    });
};

export const getVerifyReservationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof verifyReservation>>,
        TError,
        { data: VerifyReservationBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof verifyReservation>>,
    TError,
    { data: VerifyReservationBody },
    TContext
> => {
    const mutationKey = ['verifyReservation'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof verifyReservation>>,
        { data: VerifyReservationBody }
    > = (props) => {
        const { data } = props ?? {};

        return verifyReservation(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type VerifyReservationMutationResult = NonNullable<
    Awaited<ReturnType<typeof verifyReservation>>
>;
export type VerifyReservationMutationBody = VerifyReservationBody;
export type VerifyReservationMutationError = APIErrorResponseResponse;

/**
 * @summary Preflight a reservation through the show's verification script
 */
export const useVerifyReservation = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof verifyReservation>>,
        TError,
        { data: VerifyReservationBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof verifyReservation>>,
    TError,
    { data: VerifyReservationBody },
    TContext
> => {
    const mutationOptions = getVerifyReservationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Create a waitlist subscription
 */
export const addWaitlistSubscription = (
    waitlistSubscriptionCreateBodyBody: WaitlistSubscriptionCreateBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<WaitlistSubscriptionCreateSuccessResponseResponse>({
        url: `/reservation/waitlist`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: waitlistSubscriptionCreateBodyBody,
        signal,
    });
};

export const getAddWaitlistSubscriptionMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addWaitlistSubscription>>,
        TError,
        { data: WaitlistSubscriptionCreateBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addWaitlistSubscription>>,
    TError,
    { data: WaitlistSubscriptionCreateBodyBody },
    TContext
> => {
    const mutationKey = ['addWaitlistSubscription'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addWaitlistSubscription>>,
        { data: WaitlistSubscriptionCreateBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addWaitlistSubscription(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddWaitlistSubscriptionMutationResult = NonNullable<
    Awaited<ReturnType<typeof addWaitlistSubscription>>
>;
export type AddWaitlistSubscriptionMutationBody = WaitlistSubscriptionCreateBodyBody;
export type AddWaitlistSubscriptionMutationError = APIErrorResponseResponse;

/**
 * @summary Create a waitlist subscription
 */
export const useAddWaitlistSubscription = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addWaitlistSubscription>>,
        TError,
        { data: WaitlistSubscriptionCreateBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addWaitlistSubscription>>,
    TError,
    { data: WaitlistSubscriptionCreateBodyBody },
    TContext
> => {
    const mutationOptions = getAddWaitlistSubscriptionMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get reservation by id
 */
export const getReservation = (
    reservationId: number,
    params?: GetReservationParams,
    signal?: AbortSignal,
) => {
    return customInstance<GetReservation200>({
        url: `/reservation/${reservationId}`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetReservationQueryKey = (
    reservationId?: number,
    params?: GetReservationParams,
) => {
    return [`/reservation/${reservationId}`, ...(params ? [params] : [])] as const;
};

export const getGetReservationQueryOptions = <
    TData = Awaited<ReturnType<typeof getReservation>>,
    TError = APIErrorResponseResponse,
>(
    reservationId: number,
    params?: GetReservationParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getReservation>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetReservationQueryKey(reservationId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReservation>>> = ({ signal }) =>
        getReservation(reservationId, params, signal);

    return { queryKey, queryFn, enabled: !!reservationId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getReservation>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetReservationQueryResult = NonNullable<Awaited<ReturnType<typeof getReservation>>>;
export type GetReservationQueryError = APIErrorResponseResponse;

/**
 * @summary Get reservation by id
 */

export function useGetReservation<
    TData = Awaited<ReturnType<typeof getReservation>>,
    TError = APIErrorResponseResponse,
>(
    reservationId: number,
    params?: GetReservationParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getReservation>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetReservationQueryOptions(reservationId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Pay for reservation, creating transaction in orders
 */
export const payReservation = (
    reservationId: number,
    payReservationBody: PayReservationBody,
    params?: PayReservationParams,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/reservation/${reservationId}/pay`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: payReservationBody,
        params,
        signal,
    });
};

export const getPayReservationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof payReservation>>,
        TError,
        { reservationId: number; data: PayReservationBody; params?: PayReservationParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof payReservation>>,
    TError,
    { reservationId: number; data: PayReservationBody; params?: PayReservationParams },
    TContext
> => {
    const mutationKey = ['payReservation'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof payReservation>>,
        { reservationId: number; data: PayReservationBody; params?: PayReservationParams }
    > = (props) => {
        const { reservationId, data, params } = props ?? {};

        return payReservation(reservationId, data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type PayReservationMutationResult = NonNullable<Awaited<ReturnType<typeof payReservation>>>;
export type PayReservationMutationBody = PayReservationBody;
export type PayReservationMutationError = APIErrorResponseResponse;

/**
 * @summary Pay for reservation, creating transaction in orders
 */
export const usePayReservation = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof payReservation>>,
        TError,
        { reservationId: number; data: PayReservationBody; params?: PayReservationParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof payReservation>>,
    TError,
    { reservationId: number; data: PayReservationBody; params?: PayReservationParams },
    TContext
> => {
    const mutationOptions = getPayReservationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get orders by reservation id
 */
export const getOrdersByReservationId = (
    reservationId: number,
    params?: GetOrdersByReservationIdParams,
    signal?: AbortSignal,
) => {
    return customInstance<GetOrdersByReservationId200>({
        url: `/reservation/${reservationId}/orders`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetOrdersByReservationIdQueryKey = (
    reservationId?: number,
    params?: GetOrdersByReservationIdParams,
) => {
    return [`/reservation/${reservationId}/orders`, ...(params ? [params] : [])] as const;
};

export const getGetOrdersByReservationIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrdersByReservationId>>,
    TError = APIErrorResponseResponse,
>(
    reservationId: number,
    params?: GetOrdersByReservationIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getOrdersByReservationId>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetOrdersByReservationIdQueryKey(reservationId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersByReservationId>>> = ({
        signal,
    }) => getOrdersByReservationId(reservationId, params, signal);

    return { queryKey, queryFn, enabled: !!reservationId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getOrdersByReservationId>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetOrdersByReservationIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOrdersByReservationId>>
>;
export type GetOrdersByReservationIdQueryError = APIErrorResponseResponse;

/**
 * @summary Get orders by reservation id
 */

export function useGetOrdersByReservationId<
    TData = Awaited<ReturnType<typeof getOrdersByReservationId>>,
    TError = APIErrorResponseResponse,
>(
    reservationId: number,
    params?: GetOrdersByReservationIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getOrdersByReservationId>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetOrdersByReservationIdQueryOptions(reservationId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}
